import {
  CheckCircle as CheckCircleIcon,
  WarningAmber as WarningAmberIcon,
  EmojiObjects as EmojiObjectsIcon,
  HourglassEmpty as HourglassEmptyIcon,
  ErrorOutline as ErrorOutlineIcon,
} from '@mui/icons-material';

export const SubmissionDetailStatusEnumValue = {
  Pending: 0,
  Accepted: 1,
  NeedsWork: 2,
  Reworked: 3,
  ImprovementRequired: 4,
  BrpBestPractice: 5,
};

export const SubmissionDetailStatusEnum = [
  {
    value: SubmissionDetailStatusEnumValue.Pending,
    name: 'Pending',
    labelFrench: 'En attente',
    labelEnglish: 'Pending',
    color: '#FFA726',
    bgColor: 'rgba(255, 167, 38, 0.1)',
    icon: HourglassEmptyIcon,
  },
  {
    value: SubmissionDetailStatusEnumValue.Accepted,
    name: 'Accepted',
    labelFrench: 'Accepté',
    labelEnglish: 'Accepted',
    color: '#66BB6A',
    bgColor: 'rgba(102, 187, 106, 0.1)',
    icon: CheckCircleIcon,
  },
  {
    value: SubmissionDetailStatusEnumValue.NeedsWork,
    name: 'NeedsWork',
    labelFrench: 'Refusé',
    labelEnglish: 'Denied',
    color: '#EF5350',
    bgColor: 'rgba(239, 83, 80, 0.1)',
    icon: ErrorOutlineIcon,
  },
  {
    value: SubmissionDetailStatusEnumValue.Reworked,
    name: 'Reworked',
    labelEnglish: 'Reworked',
    labelFrench: 'Retravaillé',
    color: '#aece21ff',
    bgColor: 'rgba(174, 206, 33, 0.12)',
    icon: ErrorOutlineIcon,
  },
  {
    value: SubmissionDetailStatusEnumValue.ImprovementRequired,
    name: 'ImprovementRequired',
    labelEnglish: 'Improvement Required in future submissions',
    labelFrench: 'Amélioration requise dans les soumissions futures',
    color: '#FF9800',
    bgColor: 'rgba(255, 152, 0, 0.18)',
    icon: WarningAmberIcon,
  },
  {
    value: SubmissionDetailStatusEnumValue.BrpBestPractice,
    name: 'BrpBestPractice',
    labelEnglish: 'BRP Best Practice',
    labelFrench: 'Meilleure pratique BRP',
    color: '#bdc01f',
    bgColor: 'rgba(189, 192, 31, 0.18)',
    icon: EmojiObjectsIcon,
  },
];

/**
 * Get status configuration by status value
 * @param {number} statusValue - The status value from SubmissionDetailStatusEnumValue
 * @returns {Object|null} The status configuration object or null if not found
 */
export const getSubmissionDetailStatusConfig = statusValue => {
  return SubmissionDetailStatusEnum.find(status => status.value === statusValue) || null;
};

/**
 * Get localized status label
 * @param {number} statusValue - The status value from SubmissionDetailStatusEnumValue
 * @param {string} language - The current language ('en' or 'fr')
 * @returns {string} The localized label
 */
export const getSubmissionDetailStatusLabel = (statusValue, language = 'en') => {
  const config = getSubmissionDetailStatusConfig(statusValue);
  if (!config) return 'Unknown';
  return language === 'fr' ? config.labelFrench : config.labelEnglish;
};

export const SubmissionDetailStatusLabel = {
  [SubmissionDetailStatusEnumValue.Pending]: 'Pending',
  [SubmissionDetailStatusEnumValue.Accepted]: 'Accepted',
  [SubmissionDetailStatusEnumValue.NeedsWork]: 'Needs Work',
  [SubmissionDetailStatusEnumValue.Reworked]: 'Reworked',
  [SubmissionDetailStatusEnumValue.ImprovementRequired]: 'Improvement Required',
  [SubmissionDetailStatusEnumValue.BrpBestPractice]: 'BRP Best Practice',
};

export const SubmissionDetailStatusColor = {
  [SubmissionDetailStatusEnumValue.Pending]: '#FFA726', // Orange
  [SubmissionDetailStatusEnumValue.Accepted]: '#66BB6A', // Green
  [SubmissionDetailStatusEnumValue.NeedsWork]: '#EF5350', // Red
  [SubmissionDetailStatusEnumValue.Reworked]: '#aece21ff', // Yellow-green
  [SubmissionDetailStatusEnumValue.ImprovementRequired]: '#FF9800', // Orange-amber
  [SubmissionDetailStatusEnumValue.BrpBestPractice]: '#2f2f2f', // Dark text for contrast
};

export default SubmissionDetailStatusEnum;
